/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_partnership_requestCancelPartnership } from '../models/api_partnership_requestCancelPartnership';
import type { api_partnership_requestCreatePartnership } from '../models/api_partnership_requestCreatePartnership';
import type { api_partnership_requestDeletePartnership } from '../models/api_partnership_requestDeletePartnership';
import type { api_partnership_requestGetPartnershipByToken } from '../models/api_partnership_requestGetPartnershipByToken';
import type { api_partnership_requestGetPartnerships } from '../models/api_partnership_requestGetPartnerships';
import type { api_partnership_requestGetPublicPartnerships } from '../models/api_partnership_requestGetPublicPartnerships';
import type { api_partnership_requestRespondPartnership } from '../models/api_partnership_requestRespondPartnership';
import type { api_partnership_requestSearchPartnerCandidates } from '../models/api_partnership_requestSearchPartnerCandidates';
import type { api_partnership_requestSendCarelogoodInvite } from '../models/api_partnership_requestSendCarelogoodInvite';
import type { api_partnership_requestTogglePartnershipPublic } from '../models/api_partnership_requestTogglePartnershipPublic';
import type { api_partnership_responseCancelPartnership } from '../models/api_partnership_responseCancelPartnership';
import type { api_partnership_responseCreatePartnership } from '../models/api_partnership_responseCreatePartnership';
import type { api_partnership_responseDeletePartnership } from '../models/api_partnership_responseDeletePartnership';
import type { api_partnership_responseGetPartnershipByToken } from '../models/api_partnership_responseGetPartnershipByToken';
import type { api_partnership_responseGetPartnerships } from '../models/api_partnership_responseGetPartnerships';
import type { api_partnership_responseGetPublicPartnerships } from '../models/api_partnership_responseGetPublicPartnerships';
import type { api_partnership_responseRespondPartnership } from '../models/api_partnership_responseRespondPartnership';
import type { api_partnership_responseSearchPartnerCandidates } from '../models/api_partnership_responseSearchPartnerCandidates';
import type { api_partnership_responseSendCarelogoodInvite } from '../models/api_partnership_responseSendCarelogoodInvite';
import type { api_partnership_responseTogglePartnershipPublic } from '../models/api_partnership_responseTogglePartnershipPublic';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PartnershipService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create Partnership
     * 地域連携申請を作成する
     * @returns api_partnership_responseCreatePartnership responseCreatePartnership
     * @throws ApiError
     */
    public postPartnership({
        body,
    }: {
        /**
         * requestCreatePartnership
         */
        body: api_partnership_requestCreatePartnership,
    }): CancelablePromise<api_partnership_responseCreatePartnership> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partnership',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Cancel Partnership
     * 地域連携申請を取り消す
     * @returns api_partnership_responseCancelPartnership responseCancelPartnership
     * @throws ApiError
     */
    public postPartnershipCancel({
        body,
    }: {
        /**
         * requestCancelPartnership
         */
        body: api_partnership_requestCancelPartnership,
    }): CancelablePromise<api_partnership_responseCancelPartnership> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partnership/cancel',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Partnership
     * 地域連携を削除する
     * @returns api_partnership_responseDeletePartnership responseDeletePartnership
     * @throws ApiError
     */
    public postPartnershipDelete({
        body,
    }: {
        /**
         * requestDeletePartnership
         */
        body: api_partnership_requestDeletePartnership,
    }): CancelablePromise<api_partnership_responseDeletePartnership> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partnership/delete',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send Carelogood Invite
     * 地域連携先にけあログっと招待メールを送信する
     * @returns api_partnership_responseSendCarelogoodInvite responseSendCarelogoodInvite
     * @throws ApiError
     */
    public postPartnershipInviteCarelogood({
        body,
    }: {
        /**
         * requestSendCarelogoodInvite
         */
        body: api_partnership_requestSendCarelogoodInvite,
    }): CancelablePromise<api_partnership_responseSendCarelogoodInvite> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partnership/invite_carelogood',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Public Partnerships
     * 公開地域連携先一覧を取得する（認証不要）
     * @returns api_partnership_responseGetPublicPartnerships responseGetPublicPartnerships
     * @throws ApiError
     */
    public postPartnershipPublic({
        body,
    }: {
        /**
         * requestGetPublicPartnerships
         */
        body: api_partnership_requestGetPublicPartnerships,
    }): CancelablePromise<api_partnership_responseGetPublicPartnerships> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partnership/public',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Respond Partnership
     * 地域連携申請を承認/非承認する
     * @returns api_partnership_responseRespondPartnership responseRespondPartnership
     * @throws ApiError
     */
    public postPartnershipRespond({
        body,
    }: {
        /**
         * requestRespondPartnership
         */
        body: api_partnership_requestRespondPartnership,
    }): CancelablePromise<api_partnership_responseRespondPartnership> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partnership/respond',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search Partner Candidates
     * 地域連携先候補を検索する
     * @returns api_partnership_responseSearchPartnerCandidates responseSearchPartnerCandidates
     * @throws ApiError
     */
    public postPartnershipSearchCandidates({
        body,
    }: {
        /**
         * requestSearchPartnerCandidates
         */
        body: api_partnership_requestSearchPartnerCandidates,
    }): CancelablePromise<api_partnership_responseSearchPartnerCandidates> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partnership/search_candidates',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Toggle Partnership Public
     * 地域連携の公開/非公開を切り替える
     * @returns api_partnership_responseTogglePartnershipPublic responseTogglePartnershipPublic
     * @throws ApiError
     */
    public postPartnershipTogglePublic({
        body,
    }: {
        /**
         * requestTogglePartnershipPublic
         */
        body: api_partnership_requestTogglePartnershipPublic,
    }): CancelablePromise<api_partnership_responseTogglePartnershipPublic> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partnership/toggle_public',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Partnership By Token
     * トークンで地域連携情報を取得する（承認用）
     * @returns api_partnership_responseGetPartnershipByToken responseGetPartnershipByToken
     * @throws ApiError
     */
    public postPartnershipToken({
        body,
    }: {
        /**
         * requestGetPartnershipByToken
         */
        body: api_partnership_requestGetPartnershipByToken,
    }): CancelablePromise<api_partnership_responseGetPartnershipByToken> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partnership/token',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Partnerships
     * 地域連携一覧を取得する
     * @returns api_partnership_responseGetPartnerships responseGetPartnerships
     * @throws ApiError
     */
    public postPartnerships({
        body,
    }: {
        /**
         * requestGetPartnerships
         */
        body: api_partnership_requestGetPartnerships,
    }): CancelablePromise<api_partnership_responseGetPartnerships> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partnerships',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
}
